import { useTransition } from '@react-spring/web';
import { Mission } from '@edwin-group/cj-graphql';

export const useAnimatedMissions = (missions: Mission[]) => {
  const transitions = useTransition(missions, {
    keys: (mission: Mission) => mission.slug,
    from: {
      opacity: 0,
      transform: 'translateY(20px) scale(0.95)',
    },
    enter: (_: Mission, index: number) => ({
      opacity: 1,
      transform: 'translateY(0px) scale(1)',
      delay: index * 100,
    }),
    leave: {
      opacity: 0,
      transform: 'translateY(-20px) scale(0.95)',
    },
    update: {
      opacity: 1,
      transform: 'translateY(0px) scale(1)',
    },
    config: {
      tension: 300,
      friction: 30,
    },
  });

  return transitions;
};
